import {getCurrentYear} from '../../utils/commons'
import BestStaubsaugerLogo from './logo'
import {besteStaubsaugerStylesDE} from './styles'

const baseConfig = {
  domainName: 'bestestaubsauger' as const,
  domainType: 'picks' as const,
  siteName: 'Best Staubsauger',
  favicon: '/favicons/bestestaubsauger.png',
}

const localeConfigs = {
  de: {
    measurementId: 'G-7SVWBWQH04',
    camelCaseUrl: 'BestStaubsauger.de',
    logo: <BestStaubsaugerLogo className="size-10 shrink-0 tablet:size-8" locale="de" />,
    title: (category: string, count: string) =>
      `${count} Beste ${category} ${getCurrentYear()} in DE | Es gibt einen klaren Gewinner | BesteStaubsauger.de`,
    description: (_category?: string, _count?: string) =>
      `BesteStaubsauger.de – Expertenbewertungen für Saugroboter & Staubsauger. Wir analysieren tausende Produkte, damit du den besten Helfer für dein Zuhause findest!`,
    styles: besteStaubsaugerStylesDE,
  },
}

export const createConfig = (locale: string = 'de') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.de
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
